import React, { useState } from "react";
import { LEVEL_COLORS, FLUENCY_LEVELS } from "./constants";

export const AccuracyProgressBar = ({ accuracyPercent, activeCategory }) => {
  return (
    <div className="mb-4 text-end" style={{ direction: "rtl" }}>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <span className="fw-bold text-muted" style={{ fontSize: "15px" }}>
          نسبة دقة القراءة
        </span>
        <span
          className="fw-bold"
          style={{
            fontSize: "16px",
            color: activeCategory?.color || "#10b981",
          }}
        >
          {accuracyPercent}% ({activeCategory?.title})
        </span>
      </div>
      <div
        className="progress"
        style={{
          height: "8px",
          backgroundColor: "#f1f5f9",
          borderRadius: "4px",
        }}
      >
        <div
          className="progress-bar"
          role="progressbar"
          style={{
            width: `${accuracyPercent}%`,
            backgroundColor: activeCategory?.color || "#10b981",
            borderRadius: "4px",
            transition: "width 0.4s ease",
          }}
          aria-valuenow={accuracyPercent}
          aria-valuemin="0"
          aria-valuemax="100"
        />
      </div>
    </div>
  );
};

export const FluencyRatingBar = ({ fluencyScore }) => {
  return (
    <div className="mb-4 text-end" style={{ direction: "rtl" }}>
      <div className="fw-bold text-muted mb-2" style={{ fontSize: "15px" }}>
        الطلاقة
      </div>

      <div className="d-flex gap-2 w-100 mb-2">
        {FLUENCY_LEVELS.map((level, idx) => {
          const color = level.color || LEVEL_COLORS[idx];
          const isSelected = fluencyScore === idx;
          return (
            <div
              key={idx}
              style={{
                flex: 1,
                height: isSelected ? "8px" : "4px",
                backgroundColor: isSelected ? color : "#e2e8f0",
                opacity: isSelected ? 1 : 0.6,
                borderRadius: "4px",
                transition: "all 0.2s ease",
              }}
            />
          );
        })}
      </div>

      <div className="d-flex justify-content-between text-center w-100">
        {FLUENCY_LEVELS.map((level, idx) => {
          const isSelected = fluencyScore === idx;
          const color = level.color || LEVEL_COLORS[idx];
          return (
            <div
              key={idx}
              style={{
                flex: 1,
                fontSize: "13px",
                fontWeight: isSelected ? "bold" : "normal",
                color: isSelected ? color : "#94a3b8",
                transition: "all 0.2s ease",
              }}
            >
              {level.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const NotesToggleInput = ({
  notes,
  setNotes,
  label = "ملاحظات التقييم:",
  placeholder = "اضف ملاحظاتك هنا...",
}) => {
  const [showNotesField, setShowNotesField] = useState(
    (notes || "").trim().length > 0,
  );

  if (!showNotesField && (!notes || !notes.trim())) {
    return (
      <button
        className="w-100 btn text-muted d-flex align-items-center justify-content-center gap-2 border rounded-3 py-2"
        style={{
          borderColor: "#cbd5e1",
          backgroundColor: "#ffffff",
        }}
        onClick={() => setShowNotesField(true)}
      >
        <span style={{ fontSize: "18px", fontWeight: "300" }}>+</span> أضف
        ملاحظات
      </button>
    );
  }

  return (
    <div className="d-flex flex-column text-end" style={{ direction: "rtl" }}>
      {label && (
        <label
          className="fw-bold mb-1"
          style={{ fontSize: "14px", color: "#475569" }}
        >
          {label}
        </label>
      )}
      <textarea
        className="notes-textarea text-end p-3"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        placeholder={placeholder}
        style={{ minHeight: "90px" }}
      />
    </div>
  );
};
